import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** The one quiet, centred empty message for lists, feeds and grids. */
export function EmptyState({
  children,
  className,
  variant = "list",
}: {
  children: ReactNode;
  className?: string;
  variant?: "list" | "section";
}) {
  return (
    <p
      className={cn(
        "px-4 text-center text-sm text-muted-foreground",
        variant === "section"
          ? "flex min-h-20 items-center justify-center rounded-lg border border-dotted border-border py-6"
          : "py-12",
        className,
      )}
    >
      {children}
    </p>
  );
}
